import { CssBaseline, GlobalStyles } from '@mui/material';

function CssReset() {
  return (
    <>
      <GlobalStyles
        styles={{
          html: { minHeight: '100vh' },
          body: { minHeight: '100vh' },
          '#root': {
            minHeight: '100vh',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      />
      <CssBaseline />
    </>
  );
}

export default CssReset;
